module.exports = __webpack_public_path__ + "eef85053536b13c5ead115db3263aff4.svg";